import styled from '@emotion/styled';
import Dynamic from '@base/Dynamic/Dynamic';
import useTTUStore from '@stores/ttu';
import { getTTUSource } from '@stores/selectors/ttuSelectors';

const Drawer = Dynamic(() => import('@base/Drawer/Drawer'));
const TalkToUnacademy = Dynamic(() =>
  import('@cont/TalkToUnacademy/TalkToUnacademy')
);

const StyledDrawer = styled(Drawer)`
  &.MuiDrawer-root > .MuiPaper-root {
    grid-template-rows: 60px 1fr;
  }
`;

const TTURenderer = ({
  showTTU,
  onCloseTTU,
  backButton,
  setBackButton,
  handleBackPress,
  ttuTriggerSource,
  ttuOptions
}) => {
  const ttuSource = useTTUStore(getTTUSource);

  return (
    <StyledDrawer
      drawerState={showTTU}
      onClose={onCloseTTU}
      showBackButton={backButton.value}
      hideCloseButton={backButton.value}
      onPressBack={handleBackPress}
    >
      <TalkToUnacademy
        onClose={onCloseTTU}
        source={ttuTriggerSource || ttuSource}
        setBackButton={setBackButton}
        backButton={backButton}
        ttuOptions={ttuOptions}
      />
    </StyledDrawer>
  );
};

export default TTURenderer;
